import { render } from "./staffinvoice.vue?vue&type=template&id=1fa126b0&scoped=true"
import script from "./staffinvoice.vue?vue&type=script&lang=js"
export * from "./staffinvoice.vue?vue&type=script&lang=js"

import "./staffinvoice.vue?vue&type=style&index=0&id=1fa126b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa126b0"]])

export default __exports__